//Types
import {
  GET_USER,
  USER_DETAILS,
  GET_HISTORY,
  BLOCK_UNBLOCK_SWITCH,
  GET_USER_FILTERS_META,
} from "./user.type";

//Define initialState
const initialState = {
  user: [],
  history: [],
  totalHistoryUser: 0,
  filtersMeta: { countries: [], genders: [], planTypes: [] },
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    //Get User (paginated: payload is { user, total })
    case GET_USER:
      return {
        ...state,
        user: action.payload.user,
        total: action.payload.total,
      };

    //Get User Details
    case USER_DETAILS:
      return {
        ...state,
        user: action.payload,
      };

    //Get user history
    case GET_HISTORY:
      return {
        ...state,
        history: action.payload.history,
        totalHistoryUser: action.payload.total,
      };

    case BLOCK_UNBLOCK_SWITCH:
      return {
        ...state,
        // Merge rather than replace: the blockUnblock response doesn't carry
        // list-only computed fields (e.g. devicePlatforms), so a full
        // replace would wipe those out of this row until the next refetch.
        user: state?.user?.map((user) =>
          user._id === action.payload.id ? { ...user, ...action.payload.data } : user
        ),
      };

    case GET_USER_FILTERS_META:
      return {
        ...state,
        filtersMeta: action.payload,
      };

    default:
      return state;
  }
};

export default userReducer;
